import { Icon } from "@utils/helper";

const DropdownIndicator = ({ selectProps: { menuIsOpen } }) => {
  return (
    <div className="px-1 cursor-pointer">
      <Icon
        height={13}
        color={"#486AB5"}
        className={`transition-transform duration-300  ${
          menuIsOpen ? "rotate-90" : "-rotate-90"
        }`}
        id="Arrow"
        viewBox="0 0 6 11"
      />
    </div>
  );
};

export default DropdownIndicator;
